import React from 'react';
import {Button, Col, Drawer, Layout, Menu, Row} from 'antd';
import 'antd/lib/layout/style/css';
import 'antd/lib/menu/style/css';
//import logo from '../../resources/img/logo-sider.png';
import './PrivateSider.css';
import {connect} from "react-redux";
import {push} from 'connected-react-router';
import language from "../../languages/language";
import {BarsOutlined} from "@ant-design/icons";
import logout from "../../actions/logout";
import startOver from "../../actions/startOver";
//import {ADV_FILES_ROUTE} from "../Root/routes";
import { getCustomLogos } from '../../Helpers/utils';

const {Sider} = Layout;

class PrivateSider extends React.Component {

  state = {
    fixed: false,
    visible:false
  };

  changeFixedSider(brakepoint) {
    this.setState({
      fixed: brakepoint,
    });
  }

  showDrawer = () => {
    this.setState({
      visible: !this.state.visible
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  renderMenu=()=>
  {
    return <div>
      <img className={'sider-logo'} src={getCustomLogos().base64Logo} alt=""/>
      <Menu
          theme="dark"
          mode="inline"
          style={{lineHeight: '64px'}}
          defaultSelectedKeys={['advSentToMenu']}
          onClick={()=>{this.setState({visible:false})}}
      >
        {/*<Menu.Item className={'float-right'} onClick={()=>this.props.push(ADV_FILES_ROUTE)}>
          <i className={'netco-icon'}>A</i> {language[this.props.language].advWorkflowMenu}
        </Menu.Item>*/}
        <Menu.Item key={'advSentToMenu'} className={'float-right'} onClick={this.props.startOver}>
          <i className={'netco-icon'}>C</i> {language[this.props.language].advSentToMenu}
        </Menu.Item>
        <Menu.Item key={'advLogout'} className={'float-right'} onClick={this.props.logout}>
          <i className={'netco-icon'}>I</i> {language[this.props.language].advLogout}
        </Menu.Item>
      </Menu>
    </div>
  };

  render() {
    if(!this.props.info.advisor)
      return <></>;
    if(this.state.fixed)
      return (
        <div>
          <Row style={{marginLeft:0,marginRight:0}}  gutter={24}>
            <Col span={4} style={{textAlign:'left'}}>
              <Button className={'iconBars'} htmlType={'button'} icon={<BarsOutlined/>}
                      onClick={this.showDrawer}/>
            </Col>
          </Row>
          <Drawer
              closable={true}
              onClose={this.onClose}
              visible={this.state.visible} placement={'left'}>
            {this.renderMenu()}
          </Drawer>
        </div>
      );
    return (
      <Sider
        className={this.state.fixed ? 'ant-layout-sider-fixed' : ''}
        breakpoint="sm"
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          this.changeFixedSider(broken);
        }}
      >
        {this.renderMenu()}
      </Sider>
    );
  }

}


function mapStateToProps(state) {
  return {
    language: state.auth.language,
    info:state.info
  }
}

export default connect(mapStateToProps, {push,logout,startOver})(PrivateSider);
